import { useRef, useState } from 'react';

const useTokboxSession = () => {
  const tokboxSession = useRef(null);
  const [connected, setConnected] = useState(false);
  const [hasStreams, setHasStreams] = useState(false);
  const [hasScreen, setHasScreen] = useState(false);
  const [streams, setStreams] = useState([]);
  const [reconnecting, setReconnecting] = useState(false);

  const handleConnected = () => {
    setConnected(true);
  };

  const handleDisconnected = () => {
    setConnected(false);
  };

  const handleReconnected = () => {
    setReconnecting(false);
  };

  const handleReconnecting = () => {
    setReconnecting(true);
  };

  const handleStreamsChanged = newStreams => {
    setStreams(newStreams);
    setHasStreams(newStreams.length > 0);
    setHasScreen(newStreams.find(stream => stream.videoType === 'screen'));
  };

  const register = () => ({
    ref: tokboxSession,
    onConnected: handleConnected,
    onDisconnected: handleDisconnected,
    onStreamsChanged: handleStreamsChanged,
    onReconnecting: handleReconnecting,
    onReconnected: handleReconnected,
  });

  const disconnect = () => {
    tokboxSession.current.disconnect();
  };

  return {
    register,
    disconnect,
    connected,
    reconnecting,
    hasStreams,
    hasScreen,
    streams,
  };
};

export default useTokboxSession;
